import { Box, Modal, Typography, Button } from "@mui/material";

type SessionExpiredModalProps = {
  open?: boolean;
  onConfirm: () => void;
};

const SessionExpiredModal = ({ open = true, onConfirm }: SessionExpiredModalProps) => {
  return (
    <Modal open={open} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "40%",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" component="h2" sx={{ mb: 2, color: "red" }}>
          Session expired
        </Typography>
        <Typography id="modal-description" sx={{ mb: 3 }}>
          Your session has expired. Please log in again.
        </Typography>
        <Button variant="contained" color="primary" onClick={onConfirm} sx={{ mt: 1 }}>
          Accept
        </Button>
      </Box>
    </Modal>
  );
};

export default SessionExpiredModal;
